export default {
  nav: {
    reserve: 'Réserver',
    cart: 'Panier',
    menu: 'Menu',
    language: 'Langue',
    about: "À propos",
    contact: "Contact",
    categories: "Catégories d'excursions",
  },
  hero: {
    line1: 'Goélettes, sentiers et aventures à',
    line2: 'Paraty',
    subtitle: 'Excursions en goélette, bateaux privés, jeep tour et plongée.',
    subtitleHighlight: 'Expériences uniques',
    ctaTours: 'Voir les Excursions',
    ctaContact: 'Nous Contacter',
    scroll: 'Explorer',
    statYears: "Années d'Expérience",
    statGuests: 'Passagers Heureux',
    statBeaches: 'Plages & Îles',
  },
  tours: {
    label: 'Nos Excursions',
    title: 'Découvrez le meilleur de Paraty',
    subtitle: 'Excursions soigneusement sélectionnées pour profiter de chaque instant.',
    duration: 'Durée',
    difficulty: 'Difficulté',
    from: 'À partir de',
    details: 'Voir Détails',
    seeAll: 'Voir toutes les excursions',
    limited: 'Places Limitées',
    fewLeft: 'Peu de places',
    flashDeal: 'Offre Flash',
    offerEnds: 'L\'offre expire dans :',
    offerPrice: 'Prix Offre',
    stillOffer: 'Encore en offre !',
    categories: {
      all: 'Tous',
      escunas: 'Goélettes',
      jeep: 'Excursions en Jeep',
      compartilhadas: 'Bateaux Partagés',
      privadas: 'Bateaux et Goélettes Privés',
      bolivia: 'Expédition Bolivie 🇧🇴',
    },
  },
  why: {
    label: 'Pourquoi choisir AQUAMARINA ?',
    title: 'Une expérience au-delà de la excursion',
    pillars: {
      safety: 'La sécurité avant tout',
      guides: 'Guides locaux expérimentés',
      boats: 'Embarcations de qualité',
      price: 'Prix juste et transparent',
    },
  },
  testimonials: {
    label: 'Témoignages',
    title: 'Ce que disent nos passagers',
    subtitle: "Des expériences réelles de ceux qui ont déjà navigué avec nous.",
  },
  faq: {
    label: 'Questions Fréquentes',
    title: 'Questions & Réponses',
    subtitle: "Tout ce que vous devez savoir avant d'embarquer.",
  },
  contact: {
    label: 'Réservez votre aventure',
    title: 'Contact & Réservations',
    subtitle: "Prêt à plonger dans une expérience inoubliable ?",
    form: {
      name: 'Nom complet',
      email: 'E-mail',
      phone: 'WhatsApp',
      date: "Date de l'excursion",
      message: 'Parlez-nous de votre aventure idéale',
      submit: 'Envoyer le message',
      sending: 'Envoi...',
      successTitle: 'Message envoyé !',
      successText: "Notre équipe vous contactera bientôt.",
    },
    location: 'Où nous sommes',
    attendance: 'Service Client',
    schedule1: 'Lundi au Samedi : 8h à 20h',
    schedule2: 'Dimanche : 9h à 17h',
    email: 'paraty.sirenatours@gmail.com',
    whatsappLabel: 'Service rapide',
    address: 'Av. Roberto Silveira 578, Centre — Paraty, RJ',
    mapLink: 'Voir sur Google Maps',
  },
  bolivia: {
    badge: 'Offre de Lancement',
    title: 'Découvrez la Bolivie avec Nous',
    subtitle: 'Explorez le plus grand désert de sel du monde, des lagunes colorées, des volcans et des paysages hors du commun sur l\'Altiplano Bolivien.',
    cta: 'Découvrez l\'Expédition',
    seeAll: 'Voir tous les circuits',
    highlights: ['3 Jours / 2 Nuits', 'Petit Groupe', 'Guide Expert', 'Tout Inclus'],
    openingOffer: 'Prix de Lancement',
    promoBadge: 'Prix Promo',
    promoPrice: 'Prix Promo',
    price: 'R$ 1.200',
    originalPrice: 'R$ 1.500',
    perPerson: 'par personne',
    allIncluded: 'Tout Inclus',
    includedTitle: 'Ce qui est inclus',
    accommodation: 'Hébergement 2 nuits',
    meals: 'Tous les repas',
    transport: 'Transport 4x4',
    guide: 'Guide expert',
    sunset: 'Coucher de soleil au Salar',
    flamingos: 'Flamants & Lagunes',
    newActivity: 'NOUVELLE ACTIVITÉ',
    newActivityDesc: 'Dégustation de vins boliviens d\'altitude au coucher du soleil',
  },
  footer: {
    rights: 'Tous droits réservés.',
    company: 'AQUAMARINA TOURS',
    tagline: 'Expériences océaniques uniques à Paraty',
    links: {
      home: 'Accueil',
      tours: 'Excursions',
      contact: 'Contact',
      terms: 'Termes et Conditions',
      privacy: 'Politique de Confidentialité',
    },
  },
  category: {
    back: 'Accueil',
    emptyTitle: 'Aucune excursion trouvée',
    emptyText: "Aucune excursion disponible dans cette catégorie pour l'instant.",
    ctaAll: 'Voir toutes les excursions',
  },
  booking: {
    reserve: 'Réservez votre excursion',
    date: "Date de l'excursion",
    adults: 'Adultes (10+ ans) — Prix complet',
    children: 'Enfants (5 à 9 ans) — Moitié prix',
    babies: 'Bébés (0 à 4 ans) — Gratuit',
    adultPrice: 'chaque',
    childPrice: 'chaque',
    babyPrice: 'Gratuit',
    total: 'Total estimé',
    addCart: 'Ajouter au panier',
    added: 'Ajouté !',
    cartSuccess: 'Excursion ajoutée au panier !',
    reserveNow: 'Réserver maintenant',
    pixTitle: 'Comment fonctionne la réservation ?',
    pixText1: 'Pour finaliser la réservation, vous devez payer un acompte via PIX.',
    pixText2: "Le reste du paiement est effectué le jour de l'excursion, directement sur le lieu d'embarquement.",
    pixText3: "Après le paiement de l'acompte, nous vous enverrons le voucher avec toutes les informations.",
    whatsappCta: 'Continuer la réservation via WhatsApp',
    back: 'Retour',
    selectDateAlert: "Veuillez sélectionner une date pour l'excursion.",
    whatsappModal: {
      title: 'Confirmer la Réservation',
      totalTours: 'Total des excursions',
      totalPeople: 'Total de personnes',
      grandTotal: 'Total estimé',
      priceReference: 'Prix de Référence',
      perPerson: 'Par personne',
      startingFrom: 'À partir de',
      warningTitle: "⚠️ Attention ! Lisez avant de continuer",
      warning1: 'Vous serez redirigé vers WhatsApp avec tous les détails des excursions, nombre de personnes, dates et prix.',
      warning2: 'Le montant de l\'acompte PIX sera communiqué par notre équipe sur WhatsApp selon les excursions sélectionnées.',
      warning3: 'Le paiement restant est effectué le jour de l\'excursion, directement sur le lieu d\'embarquement.',
      warning4: 'Après le paiement de l\'acompte, nous vous enverrons le voucher avec toutes les informations de votre réservation.',
      acceptTerms: 'J\'ai lu et j\'accepte. Je comprends que je serai redirigé vers WhatsApp pour finaliser la réservation.',
      acceptAndGo: 'Accepter et aller sur WhatsApp',
      cancel: 'Annuler',
      fullName: 'Votre nom complet',
      fullNamePlaceholder: 'Ex: Jean Dupont',
      nameRequired: 'Veuillez entrer votre nom complet pour continuer.',
    },
  },
  cart: {
    title: 'Votre Panier',
    empty: 'Votre panier est vide',
    emptyCta: 'Explorer les excursions',
    itemAdults: 'Adultes',
    itemChildren: 'Enfants',
    itemBabies: 'Bébés',
    remove: 'Supprimer',
    total: 'Total estimé',
    continue: 'Continuer la réservation',
    reserveAll: 'Tout réserver via WhatsApp',
  },
  notFound: {
    title: 'Page non trouvée',
    back: "Retour à l'accueil",
  },
  tour: {
    about: 'À propos de cette excursion',
    itinerary: "Itinéraire de la journée",
    included: "Ce qui est inclus",
    notIncluded: "Ce qui n'est pas inclus",
    bring: 'Quoi apporter',
    info: 'Informations pratiques',
    policy: 'Politique, Conditions & Avis Importants',
    importantNotes: 'Avis importants',
    cancellation: "Politique d'annulation",
    cancellationPolicy: "7 jours ou plus avant l’excursion : remboursement de 100 %. Entre 7 jours et 48 heures avant : retenue de 20 % (remboursement de 80 %). Moins de 48 heures avant ou absence (no-show) : aucun remboursement. Si nous annulons pour des raisons de sécurité ou de mauvais temps : remboursement de 100 %.",
    terms: 'Conditions générales',
    meetingPoint: 'Point de rencontre',
    startTime: 'Heure de départ',
    duration: 'Durée',
    difficulty: 'Difficulté',
    groupSize: 'Taille du groupe',
    related: 'Excursions que vous pourriez aussi aimer',
    reviews: 'Avis Réels',
    reviewsSubtitle: "Témoignages de ceux qui ont déjà vécu cette expérience avec AQUAMARINA.",
    back: 'Retour',
    tab: {
      descricao: 'Description',
      roteiro: 'Itinéraire',
      incluso: "Ce qui est inclus",
      levar: 'Quoi apporter',
      info: 'Informations',
      politica: 'Politique',
    },
    gallery: {
      prev: 'Image précédente',
      next: 'Image suivante',
      viewPhoto: 'Voir la photo',
    },
  },
};
